export const ACCOUNT_GET_ACCOUNT_PAGE_REQUEST = 'ACCOUNT_GET_ACCOUNT_PAGE_REQUEST';
export const ACCOUNT_GET_ACCOUNT_PAGE_SUCCESS = 'ACCOUNT_GET_ACCOUNT_PAGE_SUCCESS';
export const ACCOUNT_GET_ACCOUNT_PAGE_FAILURE = 'ACCOUNT_GET_ACCOUNT_PAGE_FAILURE';

export const ACCOUNT_GET_USER_DETAILS_REQUEST = 'ACCOUNT_GET_USER_DETAILS_REQUEST';
export const ACCOUNT_GET_USER_DETAILS_SUCCESS = 'ACCOUNT_GET_USER_DETAILS_SUCCESS';
export const ACCOUNT_GET_USER_DETAILS_FAILURE = 'ACCOUNT_GET_USER_DETAILS_FAILURE';

export const ACCOUNT_ADD_NEW_USER_REQUEST = 'ACCOUNT_ADD_NEW_USER_REQUEST';
export const ACCOUNT_ADD_NEW_USER_SUCCESS = 'ACCOUNT_ADD_NEW_USER_SUCCESS';
export const ACCOUNT_ADD_NEW_USER_FAILURE = 'ACCOUNT_ADD_NEW_USER_FAILURE';

export const ACCOUNT_UPDATE_CHANGE_USER_REQUEST = 'ACCOUNT_UPDATE_CHANGE_USER_REQUEST';
export const ACCOUNT_UPDATE_CHANGE_USER_SUCCESS = 'ACCOUNT_UPDATE_CHANGE_USER_SUCCESS';
export const ACCOUNT_UPDATE_CHANGE_USER_FAILURE = 'ACCOUNT_UPDATE_CHANGE_USER_FAILURE';

export const ACCOUNT_GET_DELIVERY_ADDRESS_LIST_REQUEST = 'ACCOUNT_GET_DELIVERY_ADDRESS_LIST_REQUEST';
export const ACCOUNT_GET_DELIVERY_ADDRESS_LIST_SUCCESS = 'ACCOUNT_GET_DELIVERY_ADDRESS_LIST_SUCCESS';
export const ACCOUNT_GET_DELIVERY_ADDRESS_LIST_FAILURE = 'ACCOUNT_GET_DELIVERY_ADDRESS_LIST_FAILURE';

export const ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_REQUEST = 'ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_REQUEST';
export const ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_SUCCESS = 'ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_SUCCESS';
export const ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_FAILURE = 'ACCOUNT_GET_RESIDENTIAL_ADDRESS_LIST_FAILURE';

export const ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_REQUEST = 'ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_REQUEST';
export const ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_SUCCESS = 'ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_SUCCESS';
export const ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_FAILURE = 'ACCOUNT_SAVE_DELIVERY_ADDRESS_LIST_FAILURE';

export const ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_REQUEST = 'ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_REQUEST';
export const ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_SUCCESS = 'ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_SUCCESS';
export const ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_FAILURE = 'ACCOUNT_EDIT_DELIVERY_ADDRESS_LIST_FAILURE';

export const ACCOUNT_DELETE_DELIVERY_ADDRESS_REQUEST = 'ACCOUNT_DELETE_DELIVERY_ADDRESS_REQUEST';
export const ACCOUNT_DELETE_DELIVERY_ADDRESS_SUCCESS = 'ACCOUNT_DELETE_DELIVERY_ADDRESS_SUCCESS';
export const ACCOUNT_DELETE_DELIVERY_ADDRESS_FAILURE = 'ACCOUNT_DELETE_DELIVERY_ADDRESS_FAILURE';

export const RESET_DELETE_SUCCESS_MESSAGE = 'RESET_DELETE_SUCCESS_MESSAGE';

export const ACCOUNT_TRANSACTION_HISTORY_REQUEST = 'ACCOUNT_TRANSACTION_HISTORY_REQUEST';
export const ACCOUNT_TRANSACTION_HISTORY_SUCCESS = 'ACCOUNT_TRANSACTION_HISTORY_SUCCESS';
export const ACCOUNT_TRANSACTION_HISTORY_FAILURE = 'ACCOUNT_TRANSACTION_HISTORY_FAILURE';

export const ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_REQUEST = 'ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_REQUEST';
export const ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_SUCCESS = 'ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_SUCCESS';
export const ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_FAILURE = 'ACCOUNT_TRANSACTION_HISTORY_SPOC_APPROVE_FAILURE';

export const ACCOUNT_TABS_STATUS_REQUEST = 'ACCOUNT_TABS_STATUS_REQUEST';
export const ACCOUNT_TABS_STATUS_SUCCESS = 'ACCOUNT_TABS_STATUS_SUCCESS';
export const ACCOUNT_TABS_STATUS_FAILURE = 'ACCOUNT_TABS_STATUS_FAILURE';

export const ACCOUNT_TRANSACTION_HISTORY_DETAILS_REQUEST = 'ACCOUNT_TRANSACTION_HISTORY_DETAILS_REQUEST';
export const ACCOUNT_TRANSACTION_HISTORY_DETAILS_SUCCESS = 'ACCOUNT_TRANSACTION_HISTORY_DETAILS_SUCCESS';
export const ACCOUNT_TRANSACTION_HISTORY_DETAILS_FAILURE = 'ACCOUNT_TRANSACTION_HISTORY_DETAILS_FAILURE';

export const ACCOUNT_TRANSACTION_HISTORY_CANCEL_REQUEST = 'ACCOUNT_TRANSACTION_HISTORY_CANCEL_REQUEST';
export const ACCOUNT_TRANSACTION_HISTORY_CANCEL_SUCCESS = 'ACCOUNT_TRANSACTION_HISTORY_CANCEL_SUCCESS';
export const ACCOUNT_TRANSACTION_HISTORY_CANCEL_FAILURE = 'ACCOUNT_TRANSACTION_HISTORY_CANCEL_FAILURE';

export const ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_REQUEST = 'ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_REQUEST';
export const ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_SUCCESS = 'ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_SUCCESS';
export const ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_FAILURE = 'ACCOUNT_TRANSACTION_HISTORY_UPDATE_DELIVERY_FAILURE';

export const ACCOUNT_GET_PROFILE_REQUEST = 'ACCOUNT_GET_PROFILE_REQUEST';
export const ACCOUNT_GET_PROFILE_SUCCESS = 'ACCOUNT_GET_PROFILE_SUCCESS';
export const ACCOUNT_GET_PROFILE_FAILURE = 'ACCOUNT_GET_PROFILE_FAILURE';

export const ACCOUNT_GET_PROFILE_WITHOUTDOC_REQUEST = 'ACCOUNT_GET_PROFILE_WITHOUTDOC_REQUEST';
export const ACCOUNT_GET_PROFILE_WITHOUTDOC_SUCCESS = 'ACCOUNT_GET_PROFILE_WITHOUTDOC_SUCCESS';
export const ACCOUNT_GET_PROFILE_WITHOUTDOC_FAILURE = 'ACCOUNT_GET_PROFILE_WITHOUTDOC_FAILURE';

export const ACCOUNT_UPDATE_PROFILE_REQUEST = 'ACCOUNT_UPDATE_PROFILE_REQUEST';
export const ACCOUNT_UPDATE_PROFILE_SUCCESS = 'ACCOUNT_UPDATE_PROFILE_SUCCESS';
export const ACCOUNT_UPDATE_PROFILE_FAILURE = 'ACCOUNT_UPDATE_PROFILE_FAILURE';

export const ACCOUNT_UPLOAD_DOCUMENTS_REQUEST = 'ACCOUNT_UPLOAD_DOCUMENTS_REQUEST';
export const ACCOUNT_UPLOAD_DOCUMENTS_SUCCESS = 'ACCOUNT_UPLOAD_DOCUMENTS_SUCCESS';
export const ACCOUNT_UPLOAD_DOCUMENTS_FAILURE = 'ACCOUNT_UPLOAD_DOCUMENTS_FAILURE';

export const ACCOUNT_DELETE_DOCUMENT_REQUEST = 'ACCOUNT_DELETE_DOCUMENT_REQUEST';
export const ACCOUNT_DELETE_DOCUMENT_SUCCESS = 'ACCOUNT_DELETE_DOCUMENT_SUCCESS';
export const ACCOUNT_DELETE_DOCUMENT_FAILURE = 'ACCOUNT_DELETE_DOCUMENT_FAILURE';

export const ACCOUNT_DOWNLOAD_DOCUMENT_REQUEST = 'ACCOUNT_DOWNLOAD_DOCUMENT_REQUEST';
export const ACCOUNT_DOWNLOAD_DOCUMENT_SUCCESS = 'ACCOUNT_DOWNLOAD_DOCUMENT_SUCCESS';
export const ACCOUNT_DOWNLOAD_DOCUMENT_FAILURE = 'ACCOUNT_DOWNLOAD_DOCUMENT_FAILURE';

export const ACCOUNT_GET_POLICY_LSIT_REQUEST = 'ACCOUNT_GET_POLICY_LSIT_REQUEST';
export const ACCOUNT_GET_POLICY_LSIT_SUCCESS = 'ACCOUNT_GET_POLICY_LSIT_SUCCESS';
export const ACCOUNT_GET_POLICY_LSIT_FAILURE = 'ACCOUNT_GET_POLICY_LSIT_FAILURE';

export const ACCOUNT_GET_POLICY_TEMPLATE_REQUEST = 'ACCOUNT_GET_POLICY_TEMPLATE_REQUEST';
export const ACCOUNT_GET_POLICY_TEMPLATE_SUCCESS = 'ACCOUNT_GET_POLICY_TEMPLATE_SUCCESS';
export const ACCOUNT_GET_POLICY_TEMPLATE_FAILURE = 'ACCOUNT_GET_POLICY_TEMPLATE_FAILURE';

export const ACCOUNT_GET_POLICY_DETAILS_REQUEST = 'ACCOUNT_GET_POLICY_DETAILS_REQUEST';
export const ACCOUNT_GET_POLICY_DETAILS_SUCCESS = 'ACCOUNT_GET_POLICY_DETAILS_SUCCESS';
export const ACCOUNT_GET_POLICY_DETAILS_FAILURE = 'ACCOUNT_GET_POLICY_DETAILS_FAILURE';

export const ACCOUNT_SAVE_POLICY_REQUEST = 'ACCOUNT_SAVE_POLICY_REQUEST';
export const ACCOUNT_SAVE_POLICY_SUCCESS = 'ACCOUNT_SAVE_POLICY_SUCCESS';
export const ACCOUNT_SAVE_POLICY_FAILURE = 'ACCOUNT_SAVE_POLICY_FAILURE';

export const ACCOUNT_DELETE_POLICY_REQUEST = 'ACCOUNT_DELETE_POLICY_REQUEST';
export const ACCOUNT_DELETE_POLICY_SUCCESS = 'ACCOUNT_DELETE_POLICY_SUCCESS';
export const ACCOUNT_DELETE_POLICY_FAILURE = 'ACCOUNT_DELETE_POLICY_FAILURE';

export const ACCOUNT_BILLING_ACCOUNT_GET_LIST_REQUEST = 'ACCOUNT_BILLING_ACCOUNT_GET_LIST_REQUEST';
export const ACCOUNT_BILLING_ACCOUNT_GET_LIST_SUCCESS = 'ACCOUNT_BILLING_ACCOUNT_GET_LIST_SUCCESS';
export const ACCOUNT_BILLING_ACCOUNT_GET_LIST_FAILURE = 'ACCOUNT_BILLING_ACCOUNT_GET_LIST_FAILURE';

export const ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_REQUEST = 'ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_REQUEST';
export const ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_SUCCESS = 'ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_SUCCESS';
export const ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_FAILURE = 'ACCOUNT_BILLING_ACCOUNT_GET_ENROLLMENT_STATUS_FAILURE';

export const SELECT_BILLING_ACCOUNT_DETAIL_NUMBER = 'SELECT_BILLING_ACCOUNT_DETAIL_NUMBER';

export const ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_REQUEST = 'ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_REQUEST';
export const ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_SUCCESS = 'ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_SUCCESS';
export const ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_FAILURE = 'ACCOUNT_BILLING_ACCOUNT_GET_SERVICE_NUMBER_LIST_FAILURE';

export const BILLING_ACCOUNT_UPDATE_CREDIT_CARD_REQUEST = 'BILLING_ACCOUNT_UPDATE_CREDIT_CARD_REQUEST';
export const BILLING_ACCOUNT_UPDATE_CREDIT_CARD_SUCCESS = 'BILLING_ACCOUNT_UPDATE_CREDIT_CARD_SUCCESS';
export const BILLING_ACCOUNT_UPDATE_CREDIT_CARD_FAILURE = 'BILLING_ACCOUNT_UPDATE_CREDIT_CARD_FAILURE';

export const CHANGE_BILLING_ADDRESS_REQUEST = 'CHANGE_BILLING_ADDRESS_REQUEST';
export const CHANGE_BILLING_ADDRESS_SUCCESS = 'CHANGE_BILLING_ADDRESS_SUCCESS';
export const CHANGE_BILLING_ADDRESS_FAILURE = 'CHANGE_BILLING_ADDRESS_FAILURE';
export const CHANGE_BILLING_ADDRESS_RESET   = 'CHANGE_BILLING_ADDRESS_RESET';

export const ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_REQUEST = 'ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_REQUEST';
export const ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_SUCCESS = 'ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_SUCCESS';
export const ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_FAILURE = 'ACCOUNT_UPLOAD_NUMBER_PORT_DOCUMENTS_FAILURE';

export const ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_REQUEST = 'ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_REQUEST';
export const ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_SUCCESS = 'ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_SUCCESS';
export const ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_FAILURE = 'ACCOUNT_DOWNLOAD_DOCUMENT_NUMBERPORT_FAILURE';

export const ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_REQUEST = 'ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_REQUEST';
export const ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_SUCCESS = 'ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_SUCCESS';
export const ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_FAILURE = 'ACCOUNT_DELETE_DOCUMENT_NUMBERPORT_FAILURE';
